module.exports = __webpack_public_path__ + "static/media/google-assistant.47ad2651.jpg";